import { useContext, useState } from "react";
import styles from "./SidebarSetup.module.scss";

import { LogoBlock } from "./LogoBlock/LogoBlock";
import { Menu } from "./Menu/Menu";
import { Bottom } from "./Bottom/Bottom";
import { Text } from "../../ui-kit/Text/Text";
import { PlatformContext } from "../../contexts/PlatformContext";

import accordeonImg from "../../assets/img/accordeon_btn.png"

export const SidebarSetup = () => {

  const userPlatform = useContext(PlatformContext);
  const platform = userPlatform.userPlatformType;
  const [showMenu, setShowMenu] = useState(platform === 'web');

  const handleClickIcon = () => {
    setShowMenu(!showMenu);
  }

  return (
    <div className={styles.sidebarWrapper}>
      <div className={styles.sidebar}>
        <div className={styles.sidebar_header}>
        <LogoBlock />
        {platform === 'mobile' && (
          <div className={styles.menuIcon}>
            <img
              className={styles.menuIcon__img}
              src={accordeonImg}
              onClick={handleClickIcon} />
          </div>
        )}
        </div>

        {(showMenu || platform === 'web') && (<Menu platform={platform} />)}
        {/*(!showMenu && platform === 'mobile') && (<Text>Заголовок меню!</Text>)*/}
        {platform === 'web' && (<Bottom />)}
      </div>
    </div>
  );
};
